import { IProduct } from '@/types/IProduct';
import { IAccount } from '@/types/IAccountsResponse';
import { IReview, IReviewMedia } from '@/types/IReviewsAndQuestion';
import { ProductCategoriesEnum } from '@/types/ProductCategoriesEnum';

// Моковые продукты (упрощенные для совместимости)
export const mockProducts: IProduct[] = [
  {
    added_at: '2021-12-02T19:34:56+00:00',
    brands: [],
    category: {
      id: 1,
      name: ProductCategoriesEnum.KOSMETIKA,
      rewrite_name: 'kosmetika'
    },
    created_at: '2022-10-11T19:34:56+00:00',
    description: 'Хайлайтер в форме стика со светоотражающими частицами.',
    hidden: false,
    id: 12,
    id_import: '111bb6fa-5349-11ec-81a9-91b157e94d1e',
    maxPrice: 257,
    minPrice: 257,
    name: 'TF COSMETICS Хайлайтер-Стик для Лица',
    offers: [],
    image: null,
    product_rewrite_name: 'tf-cosmetics-hajlajter-stik-dla-lica',
    updated_at: '2025-10-06T13:54:15+00:00',
    vendorCode: '1039823'
  },
  {
    added_at: '2022-01-15T10:00:00+00:00',
    brands: [],
    category: {
      id: 2,
      name: ProductCategoriesEnum.PARFUMERIA,
      rewrite_name: 'parfumeria'
    },
    created_at: '2022-01-15T10:00:00+00:00',
    description: 'Роскошный аромат для мужчин.',
    hidden: false,
    id: 2130,
    id_import: '222bb6fa-5349-11ec-81a9-91b157e94d2e',
    maxPrice: 39988,
    minPrice: 39988,
    name: 'BrandX Oud & Oud',
    offers: [],
    image: null,
    product_rewrite_name: 'brandx-oud-oud',
    updated_at: '2025-10-06T13:54:15+00:00',
    vendorCode: '1015885'
  },
  {
    added_at: '2022-02-20T12:00:00+00:00',
    brands: [],
    category: {
      id: 1,
      name: ProductCategoriesEnum.KOSMETIKA,
      rewrite_name: 'kosmetika'
    },
    created_at: '2022-02-20T12:00:00+00:00',
    description: 'Тональный крем для идеального покрытия.',
    hidden: false,
    id: 7894,
    id_import: '333bb6fa-5349-11ec-81a9-91b157e94d3e',
    maxPrice: 1500,
    minPrice: 1500,
    name: 'BeautyLine Тональный Крем',
    offers: [],
    image: null,
    product_rewrite_name: 'beautyliner-tonalnyj-krem',
    updated_at: '2025-10-06T13:54:15+00:00',
    vendorCode: '1008107'
  },
  {
    added_at: '2022-03-10T14:00:00+00:00',
    brands: [],
    category: {
      id: 2,
      name: ProductCategoriesEnum.PARFUMERIA,
      rewrite_name: 'parfumeria'
    },
    created_at: '2022-03-10T14:00:00+00:00',
    description: 'Экзотический аромат.',
    hidden: false,
    id: 8463,
    id_import: '444bb6fa-5349-11ec-81a9-91b157e94d4e',
    maxPrice: 25000,
    minPrice: 25000,
    name: 'PerfumeArt Kirke',
    offers: [],
    image: null,
    product_rewrite_name: 'perfumeart-kirke',
    updated_at: '2025-10-06T13:54:15+00:00',
    vendorCode: '1015181'
  },
  {
    added_at: '2022-04-05T16:00:00+00:00',
    brands: [],
    category: {
      id: 1,
      name: ProductCategoriesEnum.KOSMETIKA,
      rewrite_name: 'kosmetika'
    },
    created_at: '2022-04-05T16:00:00+00:00',
    description: 'Увлажняющий крем.',
    hidden: false,
    id: 15000,
    id_import: '555bb6fa-5349-11ec-81a9-91b157e94d5e',
    maxPrice: 800,
    minPrice: 800,
    name: 'SkinCarePro Увлажняющий Крем',
    offers: [],
    image: null,
    product_rewrite_name: 'skincarepro-uvlaznayuschij-krem',
    updated_at: '2025-10-06T13:54:15+00:00',
    vendorCode: '1023456'
  }
];

// Моковые аккаунты (упрощенные)
export const mockAccounts: IAccount[] = [
  {
    id: 2,
    phone: '79184827011',
    roles: ['ROLE_USER'],
    email: 'pisarevvlad@gmail.com',
    name: 'Владислав',
    surname: 'Писарев',
    email_confirmed: true,
    phone_confirmed: true,
    favouriteProducts: [],
    accountDeliveryAddresses: [],
    amount_purchases: 15000,
    amount_purchased: 12000,
    percent_purchased: 80
  },
  {
    id: 10,
    phone: '79251234567',
    roles: ['ROLE_USER'],
    email: 'anna.smith@example.com',
    name: 'Анна',
    surname: 'Смит',
    email_confirmed: true,
    phone_confirmed: true,
    favouriteProducts: [],
    accountDeliveryAddresses: [],
    amount_purchases: 8000,
    amount_purchased: 6500,
    percent_purchased: 81
  },
  {
    id: 3,
    phone: '79349876543',
    roles: ['ROLE_USER'],
    email: 'john.doe@example.com',
    name: 'Джон',
    surname: 'Доу',
    email_confirmed: false,
    phone_confirmed: true,
    favouriteProducts: [],
    accountDeliveryAddresses: [],
    amount_purchases: 5000,
    amount_purchased: 4000,
    percent_purchased: 80
  },
  {
    id: 4,
    phone: '79451239876',
    roles: ['ROLE_USER'],
    email: 'maria.garcia@example.com',
    name: 'Мария',
    surname: 'Гарсия',
    email_confirmed: true,
    phone_confirmed: true,
    favouriteProducts: [],
    accountDeliveryAddresses: [],
    amount_purchases: 20000,
    amount_purchased: 18000,
    percent_purchased: 90
  }
];

// Моковые медиа для отзывов
export const mockReviewMedia: IReviewMedia[] = [
  {
    id: 1,
    type: 'video',
    link: 'https://storage.yandexcloud.net/test-admin-videos-08-10-2025/sample-10s.mp4',
    created_at: '2025-10-08T10:00:00+00:00'
  },
  {
    id: 2,
    type: 'video',
    link: 'https://storage.yandexcloud.net/test-admin-videos-08-10-2025/sample-15s.mp4',
    created_at: '2025-10-08T10:00:00+00:00'
  },
  {
    id: 3,
    type: 'video',
    link: 'https://storage.yandexcloud.net/test-admin-videos-08-10-2025/sample-5s.mp4',
    created_at: '2025-10-08T10:00:00+00:00'
  },
  {
    id: 4,
    type: 'image',
    link: 'https://storage.yandexcloud.net/test-admin-videos-08-10-2025/depositphotos_12283116-stock-photo-bottle-of-perfume.jpg',
    created_at: '2025-10-08T10:00:00+00:00'
  },
  {
    id: 5,
    type: 'image',
    link: 'https://storage.yandexcloud.net/test-admin-videos-08-10-2025/depositphotos_429704240-stock-photo-bottle-perfume-flower-colored-background.jpg',
    created_at: '2025-10-08T10:00:00+00:00'
  },
  {
    id: 6,
    type: 'image',
    link: 'https://storage.yandexcloud.net/test-admin-videos-08-10-2025/depositphotos_441849800-stock-photo-silhouette-bottle-woman-perfume.jpg',
    created_at: '2025-10-08T10:00:00+00:00'
  },
  {
    id: 7,
    type: 'image',
    link: 'https://storage.yandexcloud.net/test-admin-videos-08-10-2025/flakon_dlya_parfyuma_vintazhnyy_s_pompoy_fumet_krasnyy_steklyannyy.png',
    created_at: '2025-10-08T10:00:00+00:00'
  },
  {
    id: 8,
    type: 'image',
    link: 'https://storage.yandexcloud.net/test-admin-videos-08-10-2025/images.jpg',
    created_at: '2025-10-08T10:00:00+00:00'
  },
  {
    id: 9,
    type: 'image',
    link: 'https://storage.yandexcloud.net/test-admin-videos-08-10-2025/images.png',
    created_at: '2025-10-08T10:00:00+00:00'
  }
];

// Моковые отзывы
export const mockReviews: IReview[] = [
  {
    id: 1,
    advantages: 'Легкий, натуральный блеск',
    disadvantages: 'Быстро заканчивается',
    comment: 'Отличный хайлайтер, идеально подходит для повседневного макияжа.',
    rating: 4,
    user: mockAccounts[0],
    product: mockProducts[0],
    image: [mockReviewMedia[3], mockReviewMedia[4], mockReviewMedia[5]],
    video: [mockReviewMedia[0]],
    status: { status: 'approved' },
    helpful_count: 3,
    not_helpful_count: 10,
    comments: [
      {
        id: 1,
        text: 'Согласна, очень удобный!',
        user: mockAccounts[1],
        status: { status: 'pending' },
        created_at: '2025-10-01T10:00:00+00:00',
        updated_at: '2025-10-01T10:00:00+00:00'
      }
    ],
    created_at: '2025-09-30T15:00:00+00:00',
    updated_at: '2025-09-30T15:00:00+00:00'
  },
  {
    id: 2,
    advantages: 'Роскошный аромат, долго держится',
    disadvantages: 'Дорогой',
    comment: 'Покупаю уже второй раз, очень доволен.',
    rating: 5,
    user: mockAccounts[1],
    product: mockProducts[1],
    image: [mockReviewMedia[3], mockReviewMedia[4], mockReviewMedia[5]],
    video: [mockReviewMedia[1], mockReviewMedia[0]],
    status: { status: 'pending' },
    helpful_count: 15,
    not_helpful_count: 1,
    comments: [],
    created_at: '2025-09-28T12:00:00+00:00',
    updated_at: '2025-09-28T12:00:00+00:00'
  },
  {
    id: 3,
    comment: 'Хороший тональный крем, но цвет не подошел.',
    rating: 3,
    user: mockAccounts[2],
    product: mockProducts[2],
    image: [
      mockReviewMedia[5],
      mockReviewMedia[3],
      mockReviewMedia[4],
      mockReviewMedia[5]
    ],
    video: [mockReviewMedia[2], mockReviewMedia[0]],
    status: { status: 'pending' },
    helpful_count: 5,
    not_helpful_count: 3,
    comments: [],
    created_at: '2025-09-25T14:00:00+00:00',
    updated_at: '2025-09-25T14:00:00+00:00'
  },
  {
    id: 4,
    advantages: 'Экзотический, уникальный',
    comment: 'Рекомендую всем любителям необычных ароматов!',
    rating: 5,
    user: mockAccounts[3],
    product: mockProducts[3],
    image: [
      mockReviewMedia[6],
      mockReviewMedia[3],
      mockReviewMedia[4],
      mockReviewMedia[5]
    ],
    video: [mockReviewMedia[0], mockReviewMedia[1]],
    status: { status: 'pending' },
    helpful_count: 20,
    not_helpful_count: 0,
    comments: [
      {
        id: 2,
        text: 'Полностью согласен!',
        user: mockAccounts[0],
        status: { status: 'approved' },
        created_at: '2025-09-26T16:00:00+00:00',
        updated_at: '2025-09-26T16:00:00+00:00'
      },
      {
        id: 3,
        text: 'А мне не понравилось',
        user: mockAccounts[1],
        status: { status: 'rejected' },
        created_at: '2025-09-26T16:00:00+00:00',
        updated_at: '2025-09-26T16:00:00+00:00'
      },
      {
        id: 4,
        text: 'Необычный, но приятный',
        user: mockAccounts[2],
        status: { status: 'pending' },
        created_at: '2025-09-26T16:00:00+00:00',
        updated_at: '2025-09-26T16:00:00+00:00'
      }
    ],
    created_at: '2025-09-24T11:00:00+00:00',
    updated_at: '2025-09-24T11:00:00+00:00'
  },
  {
    id: 5,
    disadvantages: 'Не очень увлажняет',
    comment: 'Ожидал большего от крема.',
    rating: 2,
    user: mockAccounts[0],
    product: mockProducts[4],
    image: [
      mockReviewMedia[7],
      mockReviewMedia[3],
      mockReviewMedia[4],
      mockReviewMedia[5]
    ],
    video: [mockReviewMedia[0]],
    status: { status: 'rejected' },
    helpful_count: 2,
    not_helpful_count: 8,
    comments: [],
    created_at: '2025-09-20T09:00:00+00:00',
    updated_at: '2025-09-20T09:00:00+00:00'
  },
  {
    id: 6,
    advantages: 'Легкая текстура, быстро впитывается',
    disadvantages: 'Не держится долго',
    comment: 'Хороший увлажняющий крем для ежедневного использования.',
    rating: 4,
    user: mockAccounts[2],
    product: mockProducts[4],
    image: [mockReviewMedia[8]],
    video: [],
    status: { status: 'approved' },
    helpful_count: 8,
    not_helpful_count: 1,
    comments: [],
    created_at: '2025-09-18T13:00:00+00:00',
    updated_at: '2025-09-18T13:00:00+00:00'
  },
  {
    id: 7,
    advantages: 'Отличное качество, стойкий',
    comment: 'Один из лучших тональных кремов, что я пробовала!',
    rating: 5,
    user: mockAccounts[3],
    product: mockProducts[2],
    image: [],
    video: [mockReviewMedia[0]],
    status: { status: 'approved' },
    helpful_count: 12,
    not_helpful_count: 0,
    comments: [
      {
        id: 5,
        text: 'Полностью согласна!',
        user: mockAccounts[0],
        status: { status: 'approved' },
        created_at: '2025-09-19T11:00:00+00:00',
        updated_at: '2025-09-19T11:00:00+00:00'
      }
    ],
    created_at: '2025-09-17T16:00:00+00:00',
    updated_at: '2025-09-17T16:00:00+00:00'
  },
  {
    id: 8,
    disadvantages: 'Цена высокая',
    comment: 'Аромат интересный, но не для повседневного использования.',
    rating: 3,
    user: mockAccounts[0],
    product: mockProducts[3],
    image: [
      mockReviewMedia[7],
      mockReviewMedia[3],
      mockReviewMedia[4],
      mockReviewMedia[5]
    ],
    video: [],
    status: { status: 'pending' },
    helpful_count: 3,
    not_helpful_count: 4,
    comments: [],
    created_at: '2025-09-15T10:00:00+00:00',
    updated_at: '2025-09-15T10:00:00+00:00'
  },
  {
    id: 9,
    advantages: 'Натуральный состав, гипоаллергенный',
    comment: 'Идеально для чувствительной кожи.',
    rating: 5,
    user: mockAccounts[1],
    product: mockProducts[0],
    image: [],
    video: [],
    status: { status: 'approved' },
    helpful_count: 18,
    not_helpful_count: 1,
    comments: [
      {
        id: 6,
        text: 'У меня тоже чувствительная кожа, попробую!',
        user: mockAccounts[2],
        status: { status: 'pending' },
        created_at: '2025-09-16T14:00:00+00:00',
        updated_at: '2025-09-16T14:00:00+00:00'
      },
      {
        id: 7,
        text: 'Согласна, очень мягкий',
        user: mockAccounts[3],
        status: { status: 'approved' },
        created_at: '2025-09-16T15:00:00+00:00',
        updated_at: '2025-09-16T15:00:00+00:00'
      }
    ],
    created_at: '2025-09-14T12:00:00+00:00',
    updated_at: '2025-09-14T12:00:00+00:00'
  },
  {
    id: 10,
    disadvantages: 'Упаковка неудобная',
    comment: 'Хороший продукт, но упаковка могла бы быть лучше.',
    rating: 4,
    user: mockAccounts[2],
    product: mockProducts[1],
    image: [],
    video: [],
    status: { status: 'pending' },
    helpful_count: 6,
    not_helpful_count: 2,
    comments: [],
    created_at: '2025-09-12T09:00:00+00:00',
    updated_at: '2025-09-12T09:00:00+00:00'
  },
  {
    id: 11,
    advantages: 'Экономичный расход, эффективный',
    comment: 'Очень довольна покупкой, буду брать еще.',
    rating: 5,
    user: mockAccounts[3],
    product: mockProducts[4],
    image: [],
    video: [],
    status: { status: 'approved' },
    helpful_count: 14,
    not_helpful_count: 0,
    comments: [],
    created_at: '2025-09-10T17:00:00+00:00',
    updated_at: '2025-09-10T17:00:00+00:00'
  },
  {
    id: 12,
    disadvantages: 'Не подошел цвет',
    comment: 'Продукт нормальный, но цвет не тот, что ожидала.',
    rating: 2,
    user: mockAccounts[0],
    product: mockProducts[2],
    image: [],
    video: [],
    status: { status: 'rejected' },
    helpful_count: 1,
    not_helpful_count: 5,
    comments: [
      {
        id: 8,
        text: 'У них есть разные оттенки, проверьте',
        user: mockAccounts[1],
        status: { status: 'pending' },
        created_at: '2025-09-11T13:00:00+00:00',
        updated_at: '2025-09-11T13:00:00+00:00'
      }
    ],
    created_at: '2025-09-08T11:00:00+00:00',
    updated_at: '2025-09-08T11:00:00+00:00'
  },
  {
    id: 13,
    advantages: 'Уникальный аромат, запоминающийся',
    disadvantages: 'Слишком интенсивный',
    comment: 'Необычный парфюм, подойдет для особых случаев.',
    rating: 4,
    user: mockAccounts[1],
    product: mockProducts[3],
    image: [],
    video: [],
    status: { status: 'approved' },
    helpful_count: 9,
    not_helpful_count: 3,
    comments: [],
    created_at: '2025-09-05T15:00:00+00:00',
    updated_at: '2025-09-05T15:00:00+00:00'
  },
  {
    id: 14,
    comment: 'Стандартный продукт, ничего особенного.',
    rating: 3,
    user: mockAccounts[2],
    product: mockProducts[0],
    image: [],
    video: [],
    status: { status: 'pending' },
    helpful_count: 4,
    not_helpful_count: 2,
    comments: [
      {
        id: 9,
        text: 'А мне нравится!',
        user: mockAccounts[3],
        status: { status: 'approved' },
        created_at: '2025-09-06T12:00:00+00:00',
        updated_at: '2025-09-06T12:00:00+00:00'
      },
      {
        id: 10,
        text: 'Согласен, обычный',
        user: mockAccounts[0],
        status: { status: 'pending' },
        created_at: '2025-09-06T13:00:00+00:00',
        updated_at: '2025-09-06T13:00:00+00:00'
      }
    ],
    created_at: '2025-09-03T14:00:00+00:00',
    updated_at: '2025-09-03T14:00:00+00:00'
  },
  {
    id: 15,
    advantages: 'Качественный, профессиональный',
    comment: 'Рекомендую всем, кто ищет хороший уход.',
    rating: 5,
    user: mockAccounts[3],
    product: mockProducts[1],
    image: [],
    video: [],
    status: { status: 'approved' },
    helpful_count: 22,
    not_helpful_count: 1,
    comments: [],
    created_at: '2025-08-30T10:00:00+00:00',
    updated_at: '2025-08-30T10:00:00+00:00'
  },
  {
    id: 16,
    advantages:
      'Невероятно стойкий аромат, который держится на коже более 12 часов! Я работаю в офисе, и даже после долгого рабочего дня запах остается таким же интенсивным, как утром. Флакон очень красивый, элегантный дизайн отлично смотрится на туалетном столике. Упаковка была идеальной, пришло все целым без повреждений. Аромат раскрывается постепенно - сначала цитрусовые нотки, потом древесные, а в конце появляется легкая сладость. Очень многогранный и интересный парфюм!',
    disadvantages:
      'Единственный минус - это цена, конечно. Для обычного потребителя это довольно дорого. Хотелось бы видеть более доступные варианты или акции. Также флакон без дозатора, что не очень удобно при использовании. Первые 15 минут после нанесения аромат очень резкий, нужно привыкнуть. Не подойдет для людей, которые предпочитают легкие ненавязчивые запахи.',
    comment:
      'Купила этот парфюм по рекомендации подруги и не пожалела! Это действительно люксовый продукт, который стоит своих денег. Я обычно очень придирчиво отношусь к ароматам, но этот покорил меня с первого раза. Использую его для особых случаев - свидания, важные встречи, торжественные мероприятия. Получаю много комплиментов! Люди часто спрашивают, что за аромат. Единственное, что хочу отметить - нужно наносить совсем чуть-чуть, буквально 1-2 пшика, иначе будет слишком интенсивно. Планирую купить еще один флакон в подарок маме на день рождения. Рекомендую всем, кто ценит качественную парфюмерию и готов инвестировать в хороший аромат. Это не тот случай, когда можно сэкономить - качество действительно на высоте!',
    rating: 5,
    user: mockAccounts[1],
    product: mockProducts[1],
    image: [mockReviewMedia[3], mockReviewMedia[6], mockReviewMedia[7]],
    video: [mockReviewMedia[0], mockReviewMedia[1]],
    status: { status: 'pending' },
    helpful_count: 45,
    not_helpful_count: 3,
    comments: [
      {
        id: 101,
        text: 'Полностью согласна! Я тоже купила по рекомендации и очень довольна. Аромат действительно роскошный и стойкий.',
        user: mockAccounts[2],
        status: { status: 'approved' },
        created_at: '2025-10-02T10:30:00+00:00',
        updated_at: '2025-10-02T10:30:00+00:00',
        replies: [
          {
            id: 1001,
            text: 'Спасибо за ваш отзыв! Рады, что вам понравился продукт. Действительно, этот аромат один из самых популярных в нашем ассортименте.',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-02T11:00:00+00:00',
            updated_at: '2025-10-02T11:00:00+00:00'
          }
        ]
      },
      {
        id: 102,
        text: 'А мне показался слишком резким. Может быть, дело в индивидуальной переносимости?',
        user: mockAccounts[0],
        status: { status: 'approved' },
        created_at: '2025-10-02T14:20:00+00:00',
        updated_at: '2025-10-02T14:20:00+00:00',
        replies: [
          {
            id: 1002,
            text: 'Да, восприятие ароматов очень индивидуально. Рекомендуем наносить меньше продукта или дать ему раскрыться на коже в течение 20-30 минут. Также можете попробовать другие ароматы из нашей коллекции - у нас есть более легкие варианты.',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-02T15:00:00+00:00',
            updated_at: '2025-10-02T15:00:00+00:00'
          }
        ]
      },
      {
        id: 103,
        text: 'Подскажите, пожалуйста, есть ли у этого аромата версия в меньшем объеме? Хочу попробовать, но покупать сразу большой флакон дорого.',
        user: mockAccounts[3],
        status: { status: 'pending' },
        created_at: '2025-10-03T09:15:00+00:00',
        updated_at: '2025-10-03T09:15:00+00:00',
        replies: [
          {
            id: 1003,
            text: 'К сожалению, сейчас этот аромат доступен только в одном объеме. Но мы планируем добавить миниатюры в ближайшее время. Следите за обновлениями на сайте!',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-03T10:00:00+00:00',
            updated_at: '2025-10-03T10:00:00+00:00'
          }
        ]
      },
      {
        id: 104,
        text: 'Отличный отзыв! Очень подробно все расписали, теперь точно куплю!',
        user: mockAccounts[1],
        status: { status: 'approved' },
        created_at: '2025-10-03T16:45:00+00:00',
        updated_at: '2025-10-03T16:45:00+00:00'
      }
    ],
    created_at: '2025-10-01T18:30:00+00:00',
    updated_at: '2025-10-01T18:30:00+00:00'
  },
  {
    id: 17,
    advantages:
      'Легкая текстура, быстро впитывается, не оставляет жирного блеска. Хорошо увлажняет кожу.',
    disadvantages: 'Маленький объем за такую цену. Хотелось бы больше.',
    comment:
      'Крем использую уже месяц, результатом довольна. Кожа стала более мягкой и упругой. Подходит для ежедневного использования. Единственное - расход довольно большой, флакона хватает примерно на 3 недели при использовании утром и вечером. В целом рекомендую, но цена могла бы быть ниже.',
    rating: 4,
    user: mockAccounts[0],
    product: mockProducts[4],
    image: [mockReviewMedia[8]],
    video: [],
    status: { status: 'approved' },
    helpful_count: 28,
    not_helpful_count: 2,
    comments: [
      {
        id: 105,
        text: 'Согласна! У меня такая же проблема с расходом. Но эффект действительно хороший.',
        user: mockAccounts[2],
        status: { status: 'approved' },
        created_at: '2025-10-04T11:00:00+00:00',
        updated_at: '2025-10-04T11:00:00+00:00',
        replies: [
          {
            id: 1004,
            text: 'Рекомендуем наносить крем на слегка влажную кожу - так он лучше распределяется и расход становится более экономичным.',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-04T12:00:00+00:00',
            updated_at: '2025-10-04T12:00:00+00:00'
          }
        ]
      },
      {
        id: 106,
        text: 'Подскажите, этот крем подойдет для комбинированной кожи?',
        user: mockAccounts[1],
        status: { status: 'approved' },
        created_at: '2025-10-04T15:30:00+00:00',
        updated_at: '2025-10-04T15:30:00+00:00',
        replies: [
          {
            id: 1005,
            text: 'Да, крем универсальный и подходит для всех типов кожи, включая комбинированную. Он имеет легкую текстуру и не забивает поры.',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-04T16:00:00+00:00',
            updated_at: '2025-10-04T16:00:00+00:00'
          }
        ]
      },
      {
        id: 107,
        text: 'Отличный крем! Пользуюсь уже полгода, очень довольна результатом.',
        user: mockAccounts[3],
        status: { status: 'approved' },
        created_at: '2025-10-05T09:00:00+00:00',
        updated_at: '2025-10-05T09:00:00+00:00'
      }
    ],
    created_at: '2025-10-03T20:15:00+00:00',
    updated_at: '2025-10-03T20:15:00+00:00'
  },
  {
    id: 18,
    advantages: '',
    disadvantages:
      'Совершенно не подошел! Вызвал аллергическую реакцию - покраснение и зуд. Пришлось немедленно смыть. Очень разочарована покупкой, так как отзывы были хорошие.',
    comment:
      'К сожалению, мой опыт использования этого хайлайтера оказался негативным. Возможно, у меня индивидуальная непереносимость каких-то компонентов в составе. Но факт остается фактом - продукт не подошел. Обидно, что потратила деньги впустую. Перед покупкой внимательно изучила состав, но не нашла ничего подозрительного. Тем не менее, после нанесения буквально через 5 минут начался зуд, а через 10 минут появилось покраснение. Пришлось срочно смывать. На следующий день попробовала еще раз на небольшом участке кожи - та же реакция. Теперь лежит без дела. Не рекомендую людям с чувствительной кожей. Хотя понимаю, что это может быть моя индивидуальная особенность. Тем, у кого нормальная кожа, возможно, подойдет. Но я больше не рискну.',
    rating: 1,
    user: mockAccounts[2],
    product: mockProducts[0],
    image: [],
    video: [],
    status: { status: 'pending' },
    helpful_count: 12,
    not_helpful_count: 5,
    comments: [
      {
        id: 108,
        text: 'Очень жаль, что у вас такая реакция! Возможно, стоит обратиться к дерматологу, чтобы выяснить причину.',
        user: mockAccounts[0],
        status: { status: 'approved' },
        created_at: '2025-10-06T10:00:00+00:00',
        updated_at: '2025-10-06T10:00:00+00:00',
        replies: [
          {
            id: 1006,
            text: 'Благодарим за обратную связь! Нам очень жаль, что продукт вызвал такую реакцию. Свяжитесь, пожалуйста, с нашей службой поддержки - мы готовы предложить возврат средств или обмен на другой продукт. Ваше здоровье для нас важнее всего!',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-06T11:00:00+00:00',
            updated_at: '2025-10-06T11:00:00+00:00'
          }
        ]
      },
      {
        id: 109,
        text: 'У меня была похожая ситуация с другим продуктом этой марки. Видимо, у них какой-то общий компонент, который вызывает аллергию.',
        user: mockAccounts[1],
        status: { status: 'pending' },
        created_at: '2025-10-06T14:30:00+00:00',
        updated_at: '2025-10-06T14:30:00+00:00'
      },
      {
        id: 110,
        text: 'А мне этот хайлайтер отлично подошел! Пользуюсь уже полгода без проблем.',
        user: mockAccounts[3],
        status: { status: 'approved' },
        created_at: '2025-10-06T16:00:00+00:00',
        updated_at: '2025-10-06T16:00:00+00:00',
        replies: [
          {
            id: 1007,
            text: 'Рады, что вам продукт подошел! Действительно, реакция на косметику очень индивидуальна. Всегда рекомендуем проводить тест на небольшом участке кожи перед первым использованием.',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-06T17:00:00+00:00',
            updated_at: '2025-10-06T17:00:00+00:00'
          }
        ]
      }
    ],
    created_at: '2025-10-05T13:45:00+00:00',
    updated_at: '2025-10-05T13:45:00+00:00'
  }
];
